<script setup lang="ts">
import { mdiCogOutline } from "@mdi/js";
import { useScreenSize } from "@soft-db/ui";
import { MapItemType } from "../map/use/use-marker-manager";
import NavButton from "./NavButton.vue";

defineProps<{
	sourceType: MapItemType;
	sourceId: string;
	disabled?: boolean;
	disabledReason?: string;
}>();

const { t } = useI18n();
const { mdOrLower } = useScreenSize();
</script>

<template>
	<NavButton
		:title="t('common.settings')"
		:icon="mdiCogOutline"
		:to="{
			name: sourceType === 'station' ? 'stations-id-index' : 'sites-id-settings',
			params: { id: sourceId },
		}"
		color="default"
		:size="mdOrLower ? 'lg' : 'sm'"
		:disabled="disabled"
		:disabledReason="disabledReason"
	/>
</template>
